






import Vue from "vue";
import iconCorrect from "@tt-app/assets/Element-Overlay-Correct.svg";
import iconIncorrect from "@tt-app/assets/Element-Overlay-Incorrect.svg";

interface Props {
  isCorrect: boolean;
  overlayVisible: boolean;
}
interface Data {
  iconCorrect: string;
  iconIncorrect: string;
}
export default Vue.extend<Data, unknown, unknown, Props>({
  props: {
    isCorrect: { type: Boolean, default: null },
    overlayVisible: { type: Boolean, default: false }
  },
  data: function() {
    return {
      iconCorrect: iconCorrect,
      iconIncorrect: iconIncorrect
    };
  },
  watch: {
    overlayVisible: function(newVal) {
      if (newVal) {
        window.setTimeout(() => {
          this.$emit("hide-correctness-overlay");
        }, 1000);
      }
    }
  }
});
